module.exports = __webpack_public_path__ + "img/v_background.21640b01.svg";